import { Box, Typography } from "@mui/material";
import styles from "../css/NoGadgetFound.module.css";

interface NoGadgetFoundProps {
    platform: string,
    dataTestId: string
}

export const NoGadgetFound = ({platform, dataTestId}: NoGadgetFoundProps) => {
    return (
        <Box className={styles.container}>
            <Typography variant="body1" data-testid={dataTestId}>No Agents found for {platform}</Typography>
        </Box>
    );
}